function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { getState, setState } from '../analytics-state.js';
import { PIP, BUTTON_SUBMISSION, MODULE_CLICK, CLICKTHROUGH, SUBCONTENTDECOR, SSKU, INTERACTION, PIP_SUB_CONTENT } from '../constants.js';
export const superSku = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('super-sku.click-swatch', _ref => {
    let {
      output = {}
    } = _ref;
    const {
      attributeLabel
    } = output;
    const templates = 'zone a'; // @todo need to determine based on path (could be `zone b`)// or?

    const {
      pageInfo = {}
    } = digitalData.page;
    const {
      pageType = PIP
    } = pageInfo;
    setState(_objectSpread(_objectSpread({}, getState()), {}, {
      sskuInteraction: true,
      pageTransitionEvent: SSKU
    }));
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MODULE_CLICK
      },
      pageType,
      content: {
        widgets: [{
          action: CLICKTHROUGH,
          id: 'n/a',
          name: SUBCONTENTDECOR,
          // @TODO migrated from decor, whats the rest of the site use
          templates,
          component: 'product swatch',
          element: attributeLabel || 'color' // this is not 1-1 was "color" now Color/Finish, does that matter?
        }]
      }
    };
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('super-sku.click-super-duper-sku', () => {
    // TODO: Check if this is needed
    setState({
      superDuperSkuInteraction: true
    });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('super-sku.click-help-me-choose', _ref2 => {
    let {
      output
    } = _ref2;
    const {
      component,
      target,
      section
    } = output || {};
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: PIP_SUB_CONTENT
      },
      subContent: {
        component,
        section,
        target
      }
    };
    digitalData.event.push(ddoEvent);
  });
};
//# sourceMappingURL=super-sku.listener.analytics.js.map